export enum LinkType {
  Redirect = 'Redirect',
  File = 'File',
  Collection = 'Collection'
}

export interface LinkBaseModel {
  categoryId?: string;
  createdAt: string;
  updatedAt: string;
  name?: string;
  type: LinkType;
  description?: string;
  tags?: Record<string, string>;
  expirationDate?: string;
  password?: string;
  viewCount: number;
  lastAccessedAt?: string;
}

export interface LinkModel extends LinkBaseModel {
  id: string;
  versionId: string;
  archived: boolean;
  accountId: string;
  downloads?: number;
}

export interface LinkDestination {
  url: string;
  storagePath?: string;
  contentType?: string;
  contentLength?: number;
  fileName?: string;
}

export interface CollectionItem {
  id: string;
  name: string;
  destination: LinkDestination;
}

export interface LinkContent {
  destination?: LinkDestination;
  name?: string;
  items?: CollectionItem[];
} 